export class OrderedTicketBySettlementDate<T> {
  tickets: [{ formattedSettlementDate: string; ticketsOfTheDay: T[] }] = [
    { formattedSettlementDate: "", ticketsOfTheDay: [] },
  ];
  years: number[] = [];
  months: number[] = [];
  days: number[] = [];
  currentPage: number;
  pageCount: number;
  rowCount: number;
  listedPages: any[];
  firstRowOnPage: number;
  lastRowOnPage: number;
}
